import { DarkMaterialUITheme } from "@exabyte-io/cove.js/dist/theme";

export const theme = DarkMaterialUITheme;
